import { FormItem as CduiFormItem } from 'cdui-js';
import i18n from '../../i18n';

/**
 * 业务 FormItem：默认用 i18n 覆盖 cdui-js 硬编码的「不能为空」。
 * 单字段仍可通过 props.requiredError 自定义。
 */
export const FormItem = (props) => (
  <CduiFormItem {...props} requiredError={props.requiredError ?? i18n.Common.FormRequired}>
    {props.children}
  </CduiFormItem>
);
